import { EmailInputError } from '../types';

export const emailInputErrorValues: Record<EmailInputError, string> = {
  [EmailInputError.Duplicate]: 'Email is already on the list.',
  [EmailInputError.Domain]:
    'Your domain does not match, please use the same work domain.',
  [EmailInputError.Format]: 'Please enter a valid email address.',
};
